import {CommandStrategy} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {ApiSendCommandsController} from '../../../../../controllers/ApiSendCommandsController';
import {CardSelector} from '../../../../../controllers/CardSelector';
import {StackSelector} from '../../../../../controllers/StackSelector';
import {DynamicData} from '../../../../../data/DynamicData';

export class DeleteStacksCommandStarategy extends CommandStrategy
{
    constructor() {
        super({iconId: PieMenuIcons.DEL, hint: 'Delete'});
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        return CardSelector.selectedCards.length == 0 && !!stack && DynamicData.settings.canTableDeleteCards;
    }

    execute(commandIndex: number): void {
        let applyTo: Stack[] = StackSelector.selectedStacks.filter(stack => !stack.activeData.locked);
        if (!applyTo.length) {
            return;
        }
        ApiSendCommandsController.deleteStacks(applyTo);
    }
}
